import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import IdentificationSelector from './UnifiedIdentification'
import { actionCreators } from '@/checkout-instore-legacy/order/actions'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionCreators, dispatch),
})

export default connect(undefined, mapDispatchToProps)(IdentificationSelector)
